var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDeleteSmallWhite(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon delete"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 9",
    cx: 12,
    cy: 12,
    r: 12,
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Outline"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector 2 (Stroke)",
    d: "M8.4 8.4C8.73137 8.4 9 8.66863 9 9V16.2H15V9C15 8.66863 15.2686 8.4 15.6 8.4C15.9314 8.4 16.2 8.66863 16.2 9V16.2C16.2 16.8627 15.6627 17.4 15 17.4H9C8.33726 17.4 7.8 16.8627 7.8 16.2V9C7.8 8.66863 8.06863 8.4 8.4 8.4Z",
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#303C42"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 3 (Stroke)",
    d: "M6.6 8.4C6.6 8.06863 6.86863 7.8 7.2 7.8L16.8 7.8C17.1314 7.8 17.4 8.06863 17.4 8.4C17.4 8.73137 17.1314 9 16.8 9L7.2 9C6.86863 9 6.6 8.73137 6.6 8.4Z",
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#303C42"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 4 (Stroke)",
    d: "M9 7.2C9 6.53726 9.53726 6 10.2 6H13.8C14.4627 6 15 6.53726 15 7.2V8.4C15 8.73137 14.7314 9 14.4 9C14.0686 9 13.8 8.73137 13.8 8.4V7.2H10.2V8.4C10.2 8.73137 9.93137 9 9.6 9C9.26863 9 9 8.73137 9 8.4V7.2Z",
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#303C42"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteSmallWhite);
export default __webpack_public_path__ + "static/media/DeleteSmallWhite.86f1d587d5775bdfe8c64c6d7f12ce7d.svg";
export { ForwardRef as ReactComponent };